// extracted by mini-css-extract-plugin
module.exports = {"item":"MoreMembers_item__frotz","playersCount":"MoreMembers_playersCount__1B9FV"};